import { ThemedStyleFn } from '~src/hooks/useStyles';

export const styleFn: ThemedStyleFn = (theme) => ({
  component: {
    minWidth: theme.aboveWidth[0],
    flex: 1,
  },
  container: {
    display: 'flex',
    border: `1px solid ${theme.colors.lightGray}`,
    backgroundColor: theme.colors.gray,
    borderRadius: '2px',
    padding: '0 5px',
    overflowX: 'auto',
    minHeight: 32,
  },
  icons: {
    fontSize: '20px',
    transition: '0.2s',
    margin: '0 2px 2px 2px',
  },
  navIcon: {
    height: '23px',
    marginTop: '2px',
    marginRight: '3px',
    width: '38px',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '363px',
    marginRight: '0 auto',
  },
});
